/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Send Forgot Password Email Request Body
 * @export
 * @interface SendForgotPasswordEmailRequest
 */
export interface SendForgotPasswordEmailRequest {
    /**
     * Email
     * @type {string}
     * @memberof SendForgotPasswordEmailRequest
     */
    email: string;
    /**
     * ReCAPTCHA Token
     * @type {string}
     * @memberof SendForgotPasswordEmailRequest
     */
    recaptchaToken: string;
}

/**
 * Check if a given object implements the SendForgotPasswordEmailRequest interface.
 */
export function instanceOfSendForgotPasswordEmailRequest(value: object): value is SendForgotPasswordEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    return true;
}

export function SendForgotPasswordEmailRequestFromJSON(json: any): SendForgotPasswordEmailRequest {
    return SendForgotPasswordEmailRequestFromJSONTyped(json, false);
}

export function SendForgotPasswordEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendForgotPasswordEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'recaptchaToken': json['recaptcha_token'],
    };
}

export function SendForgotPasswordEmailRequestToJSON(value?: SendForgotPasswordEmailRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'recaptcha_token': value['recaptchaToken'],
    };
}

